export default __webpack_public_path__ + "static/N0047-5c1843f5affb025c10df37279c734c6b.png";